import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

$(() => {
    const cards = gsap.utils.toArray(".card");
    const numCards = cards.length;
    $('.cards').css('--numCards', numCards);

    // Create scroll triggers for snapping
    const tops = cards.map(card =>
        ScrollTrigger.create({
            trigger: card,
            start: "top top"
        })
    );

    // Timeline for animations
    const animationSequence = {
        ".face1": {
            "startTime": 0,
        },
        ".face2": {
            "startTime": 0.8,
        },
        ".card1": {
            "startTime": 1.2,
        },
        ".card2": {
            "startTime": .6,
        },
        ".card3": {
            "startTime": 1.8,
        }
    };

    const duration = 1.2;
    // const duration = .1;

    const tl = gsap.timeline();

    for (const [selector, { startTime }] of Object.entries(animationSequence)) {
        tl.to(selector, {
            opacity: 1,
            duration: duration,
            delay: 0,
            ease: "power2.in",
        }, startTime);
    }

    //     const headerHeight = document.querySelector('.navbar').offsetHeight;
    //     const height = card.offsetHeight + padding;
    //     return `top bottom+=${height}`;
    //     // return "top top";
    // },
    // end: () => {
    //     const headerHeight = document.querySelector('.navbar').offsetHeight;
    //     const height = card.offsetHeight + padding;
    //     return `bottom bottom`;
    //     // if (index === numCards - 2) {
    //     //     return "bottom bottom-=20%";
    //     // }
    //     if (index === numCards - 1) {
    //         // return "top bottom
    //     }
    //

    const headerPadding = 20;
    const headerHeight = document.querySelector('.navbar').offsetHeight + headerPadding + 'px';
    $('body').css('--headerHeight', headerHeight);

    $(window).on('resize', () => {
        const headerHeight = document.querySelector('.navbar').offsetHeight + headerPadding + 'px';
        $('body').css('--headerHeight', headerHeight);
    });

    // ScrollTriggers for each card
    const padding = 40;
    cards.forEach((card, index) => {
        ScrollTrigger.create({
            trigger: card,
            id: "card-" + index,
            start: () => {
                const headerHeight = document.querySelector('.navbar').offsetHeight;
                const height = headerHeight + padding;

                // console.log('height', height);
                // console.log('headerHeight', headerHeight);
                // console.log('padding', padding);

                return `top top+=${height}`;
            },
            end: () => {
                const headerHeight = document.querySelector('.navbar').offsetHeight;
                const height = headerHeight + padding;

                if (index === numCards - 1) {
                    return `bottom+=${height} bottom`;
                }
            },
            onEnter: () => $(card).addClass('active'),
            onLeaveBack: () => $(card).removeClass('active'),
            onEnterBack: () => $(card).addClass('active'),
            onLeave: () => $(card).removeClass('active'),
            pin: true,
            pinSpacing: false,
            scrub: true,
            markers: false,
        });
    });

    let videoHasPlayed = false;
    // Add scroll triggers to our video-cta div
    ScrollTrigger.create({
        trigger: ".video-cta",
        start: "top center-=20%",
        end: "bottom bottom",
        pin: false,
        pinSpacing: false,
        scrub: false,
        markers: false,
        onEnter: () => {
            let video = $(".video-cta").find("video").get(0);

            if (!videoHasPlayed) {
                video.play();
                videoHasPlayed = true;
            }
        }
    });

    // Uncomment to add snapping behavior
    /*
    ScrollTrigger.create({
        snap: {
            snapTo: (progress, self) => {
                const cardStarts = tops.map(st => st.start);
                const snapScroll = gsap.utils.snap(cardStarts, self.scroll());
                return gsap.utils.normalize(0, ScrollTrigger.maxScroll(window), snapScroll);
            },
            duration: 0.5
        }
    });
    */

    $('.subscribe-btn').on('click', (e) => {
        e.preventDefault();
        // Scroll down to .cta[0]

        const $cta = $('.cta').get(0);

        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: $cta,
                offsetY: $('.navbar').height(),
                autoKill: true,
                ease: "power2",
            }
        });
    });

    $('.back-to-top').on('click', (e) => {
        e.preventDefault();
        // Scroll back to top
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: 0,
                autoKill: true,
                ease: "power2",
            }
        });
    });

    ScrollTrigger.create({
        trigger: "body",
        start: "top+=10% top",
        end: "bottom bottom",
        onEnter: () => $('.back-to-top').addClass('active'),
        onLeaveBack: () => $('.back-to-top').removeClass('active'),
        onEnterBack: () => $('.back-to-top').addClass('active'),
        pin: false,
        pinSpacing: false,
        scrub: false,
        markers: false,
    });

    const year = new Date().getFullYear();
    $('.year').text(year);
    console.log('year', year);
});

// Experimental mouse tracking
function experimental() {
    let mouse = { x: 0, y: 0 };
    let pos = { x: 0, y: 0 };
    let ratio = 0.05;
    let active = false;
    let rafId; // Store the requestAnimationFrame ID

    // Define the elements and their initial positions
    const elems = [".face1", ".face2", ".card1", ".card2", ".card3"].map(selector => {
        const element = $(selector);
        if (element.length === 0) {
            console.warn(`Selector "${selector}" not found in the DOM.`);
            return null;
        }
        return {
            selector,
            position: {
                x: element.offset()?.left || 0,
                y: element.offset()?.top || 0
            }
        };
    }).filter(Boolean);

    // Update positions based on mouse movement
    const update = () => {
        if (!active) return; // Stop updates if not active

        pos.x += (mouse.x - pos.x) * ratio;
        pos.y += (mouse.y - pos.y) * ratio;

        elems.forEach(elem => {
            gsap.to(elem.selector, {
                x: (pos.x / 10),
                y: (pos.y / 10),
                duration: 0.1,
                overwrite: true, // Prevent overlapping tweens
            });
        });

        rafId = requestAnimationFrame(update); // Store RAF ID for potential cancellation
    };

    // Reset element positions to their initial state smoothly
    const resetPositions = () => {
        elems.forEach(elem => {
            gsap.to(elem.selector, {
                x: 0,
                y: 0,
                duration: 0.5,
                ease: "power2.out",
            });
        });
    };

    // Handle mouse movement
    const onMouseMove = e => {
        mouse.x = e.clientX;
        mouse.y = e.clientY;
    };

    // Handle mouse entering the hero element
    const onMouseEnter = () => {
        active = true; // Activate animations
        update(); // Start updating positions
    };

    // Handle mouse leaving the hero element
    const onMouseLeave = () => {
        active = false; // Deactivate animations
        // cancelAnimationFrame(rafId); // Stop RAF loop
        resetPositions(); // Smoothly reset positions
    };

    // Attach event listeners to the hero element
    $(".hero").on("mouseenter", onMouseEnter);
    $(".hero").on("mouseleave", onMouseLeave);
    $(".hero").on("mousemove", onMouseMove);
}

// Call the experimental function
$(() => {
    // experimental();
});
